var exports = {
  "Zp": "x43aef4ae--3de45b--layout",
  "Dk": "x43aef4ae--3de45b--carousel",
  "hP": "x43aef4ae--3de45b--slides",
  "CU": "x43aef4ae--3de45b--foreground",
};

module.exports = exports;
